<template>
	<div class="secondpage">
		<div class="title_top">
			<el-row :gutter="20">
				<el-col :span="16" :offset="4">
					<div class="secondpage_con">
						<h2>解决方案</h2>
						<p>根据具体项目需求提供相关技术支持</p>
					</div>
				</el-col>
			</el-row>
		</div>
		<!-- 内容 -->
		<el-row class="content">
			<el-col :span="16" :offset="4">
				<el-row class="service-list">
					<el-col :xs="24">
						<h1>技术服务范围</h1>
						<p>根据具体项目需求及双方约定，提供网站与业务系统开发、系统对接、数据存储与备份、部署及运维等技术支持。</p>
					</el-col>
					<el-col class="hidden-xs-only" :xs="12" :sm="6" v-for="itemlist in content" :key="itemlist.id">
						<div class="con_item">
							<img :src="'../../static/' + itemlist.imgsrc" alt="" width="50%">
							<h3>{{itemlist.title}}</h3>
							<p>{{itemlist.content}}</p>
						</div>
					</el-col>
					<el-col class="hidden-sm-and-up" :xs="12" :sm="6" v-for="itemlist in content" :key="itemlist.title">
						<div class="con_item">
							<img :src="'../../static/' + itemlist.imgsrc" alt="" width="50%">
							<h5>{{itemlist.title}}</h5>
							<p>{{itemlist.content}}</p>
						</div>
					</el-col>
				</el-row>
			</el-col>
		</el-row>

	</div>
</template>

<script>
	export default {
		data() {
			return {
				workTask: [],
				content:[
					{id:2,
					title:'企业应用集成',
					content:'根据项目需求，提供业务系统接口对接及权限配置相关的开发支持。',
					imgsrc:'icon-integration.svg'},
					{id:3,
					title:'数据存储与备份',
					content:'根据具体项目约定，提供数据存储、备份配置及相关技术支持。',
					imgsrc:'icon-storage.svg'},
					{id:8,
					title:'网站建设解决方案',
					content:'根据项目需求，提供网站及业务系统的设计、开发与部署支持。',
					imgsrc:'icon-website.svg'}
				]
			};
		},
		created() {
			this.workTask = this.$route.query.id
			// console.log(this.workTask)
		}

	}
</script>

<style scoped>
	.content h1,.content h3,.content h5,.content p{
		color: #000000;
	}
	.title_top {
		width: 100%;
		overflow: hidden;
		margin: 0;
		color: #FFFFFF;
		background: url(../assets/1587_jgzynhtp.jpg) no-repeat center center;
		-webkit-background-size: cover;
		-moz-background-size: cover;
		-o-background-size: cover;
		background-size: cover;
	}

	.secondpage_con {
		margin: 150px auto;
	}
	.content{
		margin:80px auto ;
	}
	.service-list{
		display: flex;
		flex-wrap: wrap;
		justify-content: center;
	}
	.service-list::before,
	.service-list::after{
		display: none;
	}
	.content .el-col{
		overflow: hidden;
		/* border: 1px solid #F0F2F5; */
	}
	.con_item{
		box-sizing: border-box;
		max-height: 260px;
		max-width: 270px;
		overflow: hidden;
		border: 1px solid #F0F2F5;
		margin: 20px auto;
		padding: 3px;
	}
	.con_item p{
		font-size: 12px;
		color: #666666;
		display: inline-block;
		overflow: hidden;
		max-height: 32px;
	}
	.con_item h3,.con_item h5{
		white-space: nowrap;
	}
</style>



// WEBPACK FOOTER //
// src/components/solution.vue